import { ContactNewPasswordDTO, ContactNewPasswordResponseDTO } from "@/services/AuthService.interface"

// Store
import store from "@/store"

const newPassword = async (
	hash: string,
	password: string
): Promise<ContactNewPasswordResponseDTO | null> => {
	let response: ContactNewPasswordResponseDTO | null = null
	try {
		const dto: ContactNewPasswordDTO = {token: hash, newPassword:  password}
		response = await store.dispatch("auth/newPassword", dto)
		return response
	} catch (err) {
		console.error(err)
	}
	return response
}

export default newPassword
